import { createAsyncThunk } from '@reduxjs/toolkit'
import { H_INSTALLATION_MODULE } from 'account/constants/AccessRulesConstants'
import ApplicationConf from 'conf/ApplicationConf'
import LogAction from 'log/actions/LogAction'
import i18n from 'simple-react-i18n'
import { REJECTED, IDLE } from 'store/DataManagerConstants'
import ToastrAction from 'toastr/actions/ToastrAction'
import { genericPromise } from 'utils/ActionUtils'
import { isAuthorized } from 'utils/HabilitationUtil'

const InstallationThunk = {
    fetchInstallationsLight: createAsyncThunk(
        'fetchInstallationsLight',
        async (_, { rejectWithValue, dispatch }) => {
            try {
                const response = await genericPromise(`${ApplicationConf.installation.getAll()}?lightMode=true`, 'GET')
                return response
            } catch (err) {
                dispatch(LogAction.logError(`${i18n.fetchError} ${i18n.installations} : ${err}`))
                dispatch(ToastrAction.error(`${i18n.fetchError} ${i18n.installations}`))
                return rejectWithValue(err)
            }
        },
        {
            condition: (arg = { forceFetch: false }, { getState }) => {
                const state = getState()
                if (!isAuthorized(H_INSTALLATION_MODULE, state)) {
                    return false
                }
                const { installationsLightStatus } = state.DataManagerReducer.installation
                if (arg.forceFetch) {
                    return installationsLightStatus !== REJECTED
                }
                return installationsLightStatus === IDLE
            },
            dispatchConditionRejection: true,
        },
    ),
}

export default InstallationThunk